var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFlat = function SvgFlat(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 10,
    "data-width-16": 13,
    "data-width-20": 17,
    "data-width-24": 20,
    "data-width-28": 23,
    "data-width-72": 59,
    viewBox: "0 0 19.6 17.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.69 5.07a.75.75 0 0 1-.75-.75V1.5h-5.6a.84.84 0 0 0-.84.84v7.72h5.6a.84.84 0 0 0 .84-.84V7.9a.75.75 0 0 1 1.5 0v1.32a2.34 2.34 0 0 1-2.34 2.34H1.5v3.48a.84.84 0 0 0 .84.84h12.7a.83.83 0 0 0 .84-.84v-4.5c0-.199.08-.39.22-.53l2.12-2.11a.74.74 0 0 1 1.06 0 .75.75 0 0 1 0 1.06l-1.9 1.89v4.19a2.34 2.34 0 0 1-2.34 2.34H2.34A2.34 2.34 0 0 1 0 15.04V2.34A2.34 2.34 0 0 1 2.34 0h12.7a2.34 2.34 0 0 1 2.34 2.34v4.5a.75.75 0 1 1-1.5 0v-4.5a.83.83 0 0 0-.84-.84h-5.6v2.82a.74.74 0 0 1-.75.75",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFlat);
export default ForwardRef;